import { createElement } from "react";
import { DotLegalInfoDialog } from "@dotlegal/dotlegal-ui-components";
import { DefaultViewDialogProps } from "../SavedViewsMenu.types.ts";
import { useSetCustomerDefaultViewHook } from "./SetCustomerDefaultSavedViewDialog.hooks.ts";
import { useTranslation } from "../../../../localization/useTranslation.ts";
import { Trans } from "react-i18next";

function SetCustomerDefaultSavedViewDialog({ view, savedViewType, scopeId, secondaryScopeId, onClose, onSuccess }: DefaultViewDialogProps) {
    const { translateString } = useTranslation();
    const { handleSetCustomerDefault, inProgress } = useSetCustomerDefaultViewHook({
        view,
        savedViewType,
        scopeId,
        secondaryScopeId,
        onClose,
        onSuccess,
    });

    const handleConfirm = () => {
        handleSetCustomerDefault();
    };

    return (
        <DotLegalInfoDialog
            onCloseDialog={onClose}
            header={translateString("setAsOrganisationDefaultView")}
            btnText={translateString("save")}
            onBtnClick={handleConfirm}
            inProgress={inProgress}
            content={createElement(Trans, { i18nKey: "saveViewAsCustomerStandardTooltip", values: { name: view.name } })}
        />
    );
}

export default SetCustomerDefaultSavedViewDialog;
